// extracted by mini-css-extract-plugin
var _1 = "x22Gi";
var _2 = "JlX0U";
export { _1 as "base", _2 as "empty" }
